import "../../../../assets/presentation/components/controls/symbol/symbol-CmJHW8wF.css";
/* empty css       */
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/symbol/symbol.tsx
var SymbolColor = /* @__PURE__ */ function(SymbolColor) {
	SymbolColor["DEFAULT"] = "default";
	SymbolColor["WHITE"] = "white";
	SymbolColor["BLUE"] = "blue";
	SymbolColor["NEUTRAL"] = "neutral";
	SymbolColor["BLACK"] = "black";
	SymbolColor["DANGER"] = "danger";
	return SymbolColor;
}({});
var SymbolVariation = /* @__PURE__ */ function(SymbolVariation) {
	SymbolVariation["FILLED"] = "filled";
	SymbolVariation["OUTLINED"] = "outlined";
	return SymbolVariation;
}({});
var Symbol = ({ className, symbol, testId, color = "default", variation = "outlined" }) => {
	const spanRef = useRef(null);
	const [isFontLoaded, setIsFontLoaded] = useState(false);
	useEffect(() => {
		if (!document.querySelector("link[href*=\"Material+Symbols\"]")) {
			const link = document.createElement("link");
			link.href = "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:FILL,wght@0..1,100..700&display=swap";
			link.rel = "stylesheet";
			document.head.appendChild(link);
		}
		const checkFontLoaded = () => {
			return document.fonts.check("400 22px \"Material Symbols Outlined\"");
		};
		if (checkFontLoaded()) {
			setIsFontLoaded(true);
			return;
		}
		document.fonts.ready.then(() => {
			if (checkFontLoaded()) setIsFontLoaded(true);
			else setTimeout(() => {
				setIsFontLoaded(true);
			}, 100);
		});
	}, [variation]);
	if (!isFontLoaded) return null;
	return /* @__PURE__ */ jsx("span", {
		ref: spanRef,
		className: classNames(className, "symbol", variation, color !== "default" && `symbol--${color}`, "font-loaded"),
		"data-testid": testId,
		children: /* @__PURE__ */ jsx("span", {
			className: "inner-symbol",
			children: symbol
		})
	});
};
//#endregion
export { Symbol, SymbolColor, SymbolVariation };

//# sourceMappingURL=symbol2.js.map